export default __webpack_public_path__ + "static/media/razorpay-logo-white.79c653c5.svg";